export default __webpack_public_path__ + "static/media/math.6f1ed58c.png";